import { IAdmin, IAdminCreate, ICurrentUser, ITable, ServerResponse } from '../../models/models'
import { api } from '../api'
import { commonActions } from '../common.slice'

export const adminsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCurrentUser: builder.query<ICurrentUser, any>({
			query: (params) => ({
				url: 'panel-users/current',
				params,
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled
					dispatch(commonActions.setPermissions(data.permissions))
				} catch (err) {}
			},
			providesTags: ['currentUser'],
			transformResponse: (response: ServerResponse<ICurrentUser>) => response.data,
		}),
		getAdmins: builder.query<ITable<IAdmin>, any>({
			query: (params) => ({
				url: 'panel-users',
				params,
			}),
			providesTags: ['admins'],
			transformResponse: (response: ServerResponse<ITable<IAdmin>>) => ({
				...response.data,
				data: response.data.data.map((i) => ({ ...i, entityId: i.userId })),
			}),
		}),
		getAdminById: builder.query<IAdmin, { id: string | number }>({
			query: ({ id }) => ({
				url: `panel-users/${id}`,
			}),
			providesTags: ['admins'],
			transformResponse: (response: ServerResponse<IAdmin>) => response.data,
		}),
		createAdmin: builder.mutation<ServerResponse<any>, IAdminCreate>({
			query: (data) => ({
				url: 'panel-users',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['admins'],
		}),
		editAdmin: builder.mutation<ServerResponse<any>, { id: string | number; data: Omit<IAdminCreate, 'callbackUrl' | 'email'> }>({
			query: ({ id, data }) => ({
				url: `panel-users/${id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['admins'],
		}),
		changeAdminStatus: builder.mutation<ServerResponse<any>, { id: string | number }>({
			query: ({ id }) => ({
				url: `panel-users/${id}/status`,
				method: 'PUT',
			}),
			invalidatesTags: ['admins'],
		}),
		deleteAdmin: builder.mutation<ServerResponse<any>, { id: string | number }>({
			query: ({ id }) => ({
				url: `panel-users/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['admins'],
		}),
	}),
})

export const { useGetCurrentUserQuery, useGetAdminsQuery, useGetAdminByIdQuery, useCreateAdminMutation, useEditAdminMutation, useChangeAdminStatusMutation, useDeleteAdminMutation } =
	adminsApi
